import { render } from "./product-bundle-select.vue?vue&type=template&id=22a573ac"
import script from "./product-bundle-select.vue?vue&type=script&lang=js"
export * from "./product-bundle-select.vue?vue&type=script&lang=js"

import "./product-bundle-select.vue?vue&type=style&index=0&id=22a573ac&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__